export const FlowbarWrapperStyle = {
  maxWidth: '800px',
  minWidth: '300px',
  // width: { xs: 'auto', sm: 'fit-content' },
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: { xs: '80px', sm: '50px' },
  marginLeft: { xs: '10px', sm: 'auto' },
  marginRight: { xs: '10px', sm: 'auto' },
  color: '#FFF',
  fontFamily: 'Inter',
  transition: 'max-width 225ms cubic-bezier(0, 0, 0.2, 1)',
};

export const ExitSliderStyle = {
  position: 'absolute',
  top: 20,
  left: 0,
  right: 0,
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '310px',
  width: '100%',
  padding: '8px 10px 8px 14px',
  alignItems: 'center',
  borderRadius: '12px',
  justifyContent: 'space-between',
  background: 'rgba(0, 0, 0, 0.75)',
  boxShadow: '0px 5px 6px -3px rgba(0, 0, 0, 0.25)',
  backdropFilter: 'blur(7.5px)',
  height: '43px',
  p: '14px',
  color: '#FFF',
};

export const ActionsWrapperStyle = {
  borderRadius: '10px 10px 0px 0px',
  background: 'rgba(0, 0, 0, 0.40)',
  height: '29px',
  maxWidth: '235px',
  alignSelf: 'flex-end',
  alignItems: 'center',
  overflow: 'hidden',
};

export const ActionSectionStyle = {
  p: '0 8px',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  '&:hover': {
    background:
      ' linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), rgba(0, 0, 0, 0.40)',
  },
};

export const FlowbarBodyStyle = {
  alignItems: 'center',
  justifyContent: 'flex-start',
  background: 'rgba(0, 0, 0, 0.7)',
  boxShadow: '0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)',
  backdropFilter: 'blur(20px)',
  p: '12px',
  flexWrap: 'wrap',
};

export const ImageContainerStyle = {
  alignItems: 'center',
  justifyContent: 'center',
  width: '50px',
  height: '50px',
  borderRadius: '8px',
  background: 'transparent',
  '& img': {
    width: 'inherit',
    height: 'inherit',
    borderRadius: '8px',
  },
};

export const PrevButtonStyle = {
  height: '42px',
  borderRadius: '35px',
  border: '1px solid rgba(0, 0, 0, 0.10)',
  background: '#FFF',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    background:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), radial-gradient(551.97% 120.63% at 92.59% 11.9%, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.00) 100%), var(--White, #FFF)',
  },
};

export const TPButtonStyle = {
  height: '42px',
  borderRadius: '35px',
  border: '1px solid #2055FF',
  background: '#FFF',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    background: '#FFF',
  },
};

export const TriggerButtonStyle = {
  borderRadius: '35px',
  height: '42px',
  // maxWidth: { xs: 'unset', sm: '168px' },
  minWidth: { xs: 'unset', sm: '140px' },
  maxWidth: { xs: 'unset', sm: 'fit-content' },
  width: 'auto',
  padding: '0 20px',
  background: '#2055FF',
  '&:hover': {
    background:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), radial-gradient(551.97% 120.63% at 92.59% 11.9%, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.00) 100%), var(--Blue-Main, #2055FF)',
  },
};
